export default {
  pagination: {
    sortBy: 'start_at',
    descending: true,
    rowsPerPage: 25,
  },
  phasePlayerIds: {},
  form: {
    title: '',
    startAt: '',
    phases: [],
  },
};



// WEBPACK FOOTER //
// ./src/store/trainings/state.js